import { render, staticRenderFns } from "./additionalFields.vue?vue&type=template&id=50bd8434"
import script from "./additionalFields.vue?vue&type=script&lang=js"
export * from "./additionalFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports